/* src/app/shared/common-ui/lib/dropdown/dropdown.component.less */
:host {
  max-width: 30rem;
}
:host .dropdown {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 3.6rem;
  -webkit-user-select: none;
  user-select: none;
}
:host .dropdown.active {
  border-bottom: none;
  border-color: var(--color-default-focus);
}
:host .dropdown .action {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 0 0.6rem 0 1.2rem;
  font-size: 1.5rem;
  background: var(--color-default-input-background);
  border: 0.1rem solid var(--color-default-input-border);
  cursor: pointer;
}
:host .dropdown .action.open {
  border-color: var(--color-default-theme);
  outline: 0 solid var(--color-default-focus);
}
:host .dropdown .action .value {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host .dropdown .action .value.placeholder {
  color: var(--color-default-text-help);
}
:host .dropdown .action .icon {
  flex: none;
  height: 2.8rem;
  width: 2.8rem;
  background: var(--color-default-icon);
  mask: url("data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2236px%22%20height%3D%2236px%22%20viewBox%3D%220%200%2036%2036%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2061%20(89581)%20-%20https%3A%2F%2Fsketch.com%20--%3E%0A%20%20%20%20%3Ctitle%3E2%20Icons%20%2F%20Input%20Field%20%2F%20Dropdown%20Arrow%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22path-1%22%20points%3D%2218%2020.5%2013%2015.5%2023%2015.5%22%3E%3C%2Fpolygon%3E%0A%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%3Cg%20id%3D%222-Icons-%2F-Input-Field-%2F-Dropdown-Arrow%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2236%22%20height%3D%2236%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22Arrow-Down%22%20fill%3D%22%23353B3E%22%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E") no-repeat center;
  mask-size: 2.8rem 2.8rem;
}
:host .dropdown .action .icon.disabled {
  background: var(--color-default-text);
}
:host .dropdown .popup {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: initial;
  background: var(--color-dropdown-popup-background);
}
:host .dropdown .search {
  flex: none;
  padding: 1.2rem;
  background: var(--color-default-input-background);
}
:host .dropdown .footer:not(:empty) {
  flex: none;
  display: flex;
  align-items: center;
  padding: 1.2rem;
}
:host .dropdown .footer:not(:empty) .start {
  flex: 1;
  display: flex;
}
:host .dropdown .footer:not(:empty) .end {
  flex: none;
  display: flex;
  margin-left: 1.2rem;
}
/*# sourceMappingURL=dropdown.component.css.map */
